<div *ngIf="section.description && section.description.length>0" [innerHtml]="section.description"></div>
<div class="main-scrolling-area data-survey-background">
  <div class="fixed-width-area">
    <div class="tree-container flex flex-col full-grow-no-shrink-no-basis">
      <mat-tree class="custom-tree" [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node class="custom-tree-node" style="position:relative" [id]="node.id"
                       [ngClass]="{'control-show': node.item.id === selectedNodeId,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                       attr.question-id="{{node.item.questionId}}"
                       (click)="onSelectedNode(node); $event.stopPropagation();" *matTreeNodeDef="let node"
                       matTreeNodeToggle matTreeNodePadding>
          <div class="node-wrapper w-p-100 flex flex-col justify-start items-start"
               [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
            <div class="w-p-100 flex flex-row justify-start items-center">
              <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                <div class="button-container">
                  <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                          [attr.aria-label]="'toggle ' + node.item?.title">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                </div>
                <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                  <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                       class="tagg flex flex-row justify-start items-center">
                    <div class="custom-icon flex flex-col">
                      <span></span>
                      <span></span>
                    </div>
                    {{node.item?.conditionDisplayText}}</div>
                  <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
                    <div>{{node.item?.questionId}}.</div>
                    <div class="m-l-5">{{node.item?.title}}.</div>
                    <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
                    <i *ngIf="node.item?.hasNotes" style="cursor: pointer;"
                       (click)="openDetailsAndInstructions(node); openDetailsAndInstructions;"
                       class="fal fa-info-circle m-l-10"></i>
                    <div class="description flex-1-0-auto"
                         title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>
                  </div>
                </div>
              </div>
              <div class="right-section m-r-14">
                <button matTooltip="Ask XatBot" *ngIf="!node.item.isHidden && node.item.hasQualifyingSurvey" (click)="askXatBot(node)" mat-icon-button class="icon-dropdown-button border-radius-8 m-r-5" color="rainbow">
                  <i class="fa-solid fa-sparkles"></i>
                </button>
                <button matTooltip="More..." mat-icon-button
                        class="no-animation-btn icon-dropdown-button" [matMenuTriggerFor]="actionMenu">
                  <mat-icon class="s-20">more_horiz</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                  <button
                    *ngIf="!node.item.isHidden && fieldDefinitions[node.item.fieldKey]&& fieldDefinitions[node.item.fieldKey].isReadOnly==false"
                    mat-menu-item class="" (click)="onEdit(node)">
                    <span>Edit</span>
                  </button>
                  <button *ngIf="!node.item.isHidden" mat-menu-item class=""
                          (click)="openConversationForThisField(node)">
                    <span>Open Conversation</span>
                  </button>
                  <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsAndInstructions(node)">
                    <span>Details & Instructions</span>
                  </button>
                  <button *ngIf="!node.item.isHidden && node.item.hasQualifyingSurvey" mat-menu-item class="" (click)="askXatBot(node)">
                    <span>Ask XatBot</span>
                  </button>
                  <button *ngIf="node.item.hasFormulaExpression" mat-menu-item class=""
                          (click)="onToggleInputTypeForNumberField(node, 'UseFormula')">
                    <span>Use Formula <i *ngIf="node.item.useFormula" class="fa-solid fa-check"></i></span>
                  </button>
                  <button *ngIf="node.item.hasFormulaExpression" mat-menu-item class=""
                          (click)="onToggleInputTypeForNumberField(node, 'DirectInput')">
                    <span>Direct Input <i *ngIf="!node.item.useFormula" class="fa-solid fa-check"></i></span>
                  </button>
                </mat-menu>
              </div>
              <div class="tags right">
                <div *ngIf="node.item?.identityField" class="tag">
                  <span>Primary Key</span>
                </div>
                <div *ngIf="node.item?.formulaField" class="tag">
                  <span>Formula Field</span>
                </div>
                <div *ngIf="node.item?.hasFormulaExpression && !node.item?.useFormula" class="tag">
                  <span>Direct Input</span>
                </div>
                <div *ngIf="node.item?.hasFormulaExpression && node.item?.useFormula" class="tag">
                  <span>Use Formula</span>
                </div>
              </div>
            </div>

            <div attr.data-cy="{{node.item.questionId}}-qs"
                 *ngIf="rowItem && rowItem.cells && node.item.questionType !== 'Snippet'" mat-menu-item
                 (click)="onEdit(node)" class="fake-input">
              <div class="input"
                   matTooltip="{{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}"> {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}</div>
              <i class="fas fa-caret-down"></i>
            </div>
            <div class="w-p-100 flex flex-col" *ngIf="rowItem && rowItem.cells && node.item.questionType === 'Snippet'">
              <div
                [innerHtml]="rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''"></div>
            </div>

          </div>
        </mat-tree-node>

        <mat-tree-node class="custom-tree-node" [id]="node.id"
                       [ngClass]="{'control-show': node.item.id === selectedNodeId,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                       attr.question-id="{{node.item.questionId}}"
                       (click)="onSelectedNode(node); $event.stopPropagation();"
                       *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
          <div class="node-wrapper w-p-100 flex flex-col justify-start items-center"
               [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
            <div class="w-p-100 flex flex-row justify-start items-center">
              <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                <div class="button-container">
                  <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                          [attr.aria-label]="'toggle ' + node.item?.title">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                </div>
                <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
                  <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                       class="tagg flex flex-row justify-start items-center">
                    <div class="custom-icon flex flex-col">
                      <span></span>
                      <span></span>
                    </div>
                    {{node.item?.conditionDisplayText}}</div>
                  <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
                    <div>{{node.item?.questionId}}.</div>
                    <div class="m-l-5">{{node.item?.title}}.</div>
                    <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
                    <i *ngIf="node.item?.hasNotes" style="cursor: pointer;"
                       (click)="openDetailsAndInstructions(node); $event.stopPropagation();"
                       class="fal fa-info-circle m-l-10"></i>
                    <div class="description flex-1-0-auto"
                         title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>
                  </div>
                </div>
              </div>
              <div class="right-section m-r-14">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                        class="no-animation-btn icon-dropdown-button" (click)="closeRightSidebar()">
                  <mat-icon class="s-20">more_horiz</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
                  <button
                    *ngIf="!node.item.isHidden && fieldDefinitions[node.item.fieldKey]&& fieldDefinitions[node.item.fieldKey].isReadOnly==false"
                    mat-menu-item class="" (click)="onEdit(node)">
                    <span>Edit</span>
                  </button>
                  <button *ngIf="!node.item.isHidden" mat-menu-item class=""
                          (click)="openConversationForThisField(node)">
                    <span>Open Conversation</span>
                  </button>
                  <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsAndInstructions(node)">
                    <span>Details & Instructions</span>
                  </button>
                  <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="askXatBot(node)">
                    <span>XatBot</span>
                  </button>
                  <button *ngIf="node.item.hasFormulaExpression" mat-menu-item class=""
                          (click)="onToggleInputTypeForNumberField(node, 'UseFormula')">
                    <span>Use Formula <i *ngIf="node.item.useFormula" class="fa-solid fa-check"></i></span>
                  </button>
                  <button *ngIf="node.item.hasFormulaExpression" mat-menu-item class=""
                          (click)="onToggleInputTypeForNumberField(node, 'DirectInput')">
                    <span>Direct Input <i *ngIf="!node.item.useFormula" class="fa-solid fa-check"></i></span>
                  </button>
                </mat-menu>
              </div>
              <div class="tags right">
                <div *ngIf="node.item?.identityField" class="tag">
                  <span>Primary Key</span>
                </div>
                <div *ngIf="node.item?.formulaField" class="tag">
                  <span>Formula Field</span>
                </div>
                <div *ngIf="node.item?.hasFormulaExpression && !node.item?.useFormula" class="tag">
                  <span>Direct Input</span>
                </div>
                <div *ngIf="node.item?.hasFormulaExpression && node.item?.useFormula" class="tag">
                  <span>Use Formula</span>
                </div>
              </div>
            </div>
            <div attr.data-cy="{{node.item.questionId}}-qs"
                 *ngIf="rowItem && rowItem.cells && node.item.questionType !== 'Snippet'" (click)="onEdit(node)"
                 class="fake-input">
              <div class="input"
                   matTooltip="{{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}"> {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}</div>
              <i class="fas fa-caret-down"></i>
            </div>
            <div *ngIf="rowItem && rowItem.cells && node.item.metaData && node.item.questionType === 'Snippet'">
              <div
                [innerHtml]="rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''"></div>
            </div>

          </div>

        </mat-tree-node>
      </mat-tree>
    </div>
  </div>

</div>





